<template>
 <customModal :containermd="true" :bodymd="true" @closeModal="closeQueryModal()">
    <template #title>
      {{
        queryRoute === "Sdv"
          ? $t("navigations.raise query")
          : $t("navigations.alert query")
      }}
    </template>
    <template #body>
      <div class="row">
        <div class="col-12 col-lg-3 mb-2" v-if="queryRoute !== 'Sdv'">
         <label class="col-form-label">{{ $t("navigations.site code") }}</label>
          <input
            type="text"
            class="form-control mb-1 my-lg-0"
            v-model="values.siteCode"
            disabled
          />
        </div>
        <div class="col-lg-3 mb-1" v-if="queryRoute !== 'Sdv'">
          <label class="col-form-label">{{ $t("navigations.subject id") }} </label>
          <input
            type="text"
            class="form-control mb-1 my-lg-0"
            v-model="values.subjectId"
            disabled
          />
        </div>
        <div  class="col-lg-3 mb-1" v-if="queryRoute !== 'Sdv'">
          <label class="col-form-label">{{ $t("navigations.visit name") }}
          </label>
          <input
            type="text"
            class="form-control mb-1 my-lg-0"
            v-model="values.visitName"
            disabled
          />
        </div>
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{ $t("navigations.field name") }}</label>
          <input
            type="text"
            class="form-control mb-1 my-lg-0"
            v-model="values.fieldName"
            placeholder=""
            disabled
          />
        </div>
        <div class="col-lg-12 mb-1">
          <label class="col-form-label"> {{ $t("navigations.query subject") }}<sup><i class="fa fa-asterisk required"></i></sup></label>
          <input type="text" class="form-control" maxlength="1000" v-model="values.querySubject" />
            <span class="errorClass" v-if="errors[0]">
            {{ $t("navigations.please enter query subject") }}</span>
        </div>
        <div class="col-lg-12 mb-1">
          <label class="col-form-label">{{ $t("navigations.query message") }}<sup><i class="fa fa-asterisk required"></i></sup></label>
          <textarea
            class="form-control mb-1 my-lg-0"
            rows="4"
            cols="150"
            v-model="values.queryMessage"
          >
          </textarea>
          <span class="errorClass" v-if="errors[1]">{{$t("navigations.please enter query message")}}</span>
        </div>
        <div class="col-lg-4 mb-1">
          <label class="col-form-label">{{ $t("navigations.priority") }}</label>
        <select
            class="form-control m-b"
            name="account"
            v-model="values.priority"
          >
            <option value="Low">{{ $t("navigations.low") }}</option>
            <option value="Medium">{{ $t("navigations.medium") }}</option>
            <option value="High">{{ $t("navigations.high") }}</option>
        </select>
        </div>
        <div class="col-lg-4 mb-1">
          <label class="col-form-label">{{ $t("navigations.role") }}
            <sup><i class="fa fa-asterisk required"></i></sup>
          </label>
          <Multiselect
            @close="onroleClosed()"
            @clear="closebtnclicked()"
            v-model="selectedRoles"
            mode="multiple"
            valueProp="roleID"
            :placeholder="$t('navigations.select roles')"
            label="roleName"
            :options="roleList"
            :hideSelected="false"
            :closeOnSelect="false"
            :searchable="true"
            trackBy="roleName"
            class="multiselect-theme"
          >
            <template v-slot:option="{ option }">
              {{ option.roleName }}
            </template>
          </Multiselect>
          <span class="errorClass" v-if="errors[3]">{{
            $t("navigations.please select role")
          }}</span>
        </div>
        <div class="col-lg-4 mb-1">
          <label class="col-form-label"
            >{{ $t("navigations.recipients") }}
            <sup><i class="fa fa-asterisk required"></i></sup>
          </label>

          <Multiselect
            @close="onRecipientsClosed()"
            @clear="recepientclosebtnclicked()"
            v-model="values.recipients"
            mode="multiple"
            valueProp="email"
            :placeholder="$t('navigations.select recipients')"
            label="recipients"
            :options="recipients"
            :hideSelected="false"
            :closeOnSelect="false"
            :searchable="true"
            trackBy="email"
            class="multiselect-theme"
          >
            <template v-slot:option="{ option }">
              {{ option.email }}
            </template>
          </Multiselect>
          <span class="errorClass" v-if="errors[2]">{{
            $t("navigations.please select recipient")
          }}</span>
        </div>
        <div class="col-lg-12 my-2 d-flex">
          <div class="col-lg-4">
            <div class="form-group">
              <label>
                <input
                  aria-expanded="true"
                  v-model="chksendmail"
                  aria-controls="collapseExample"
                  type="checkbox"
                  @click="check()"
                />
                {{ $t("navigations.send an email alert") }}
              </label>
            </div>
            <div class="ibox" id="collapseOne" v-if="checkboxclick">
              <table
                class="
                  table table-striped table-bordered table-hover
                  dataTables-example
                  dataTable"
              >
                <tbody>
                  <tr v-for="options in emailrecipients" :key="options.id">
                    <td>
                      <input
                        type="checkbox"
                        checked="checked"
                        :value="options.isChecked"
                        v-model="options.isChecked"
                        :id="options.id"
                      />
                      {{ options.evalu }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-lg-12 my-1 d-flex">
          <div class="col-lg-12 text-right">
            <button
              class="cancel_btn py-1 px-4 mx-3"
              type="submit"
              @click="ClearData()"
            >
              {{ $t("navigations.clear") }}
            </button>
            <button
              class="save_btn py-1 px-4"
              type="submit"
              @click="createQuery()"
            >
              {{ $t("navigations.submit") }}
            </button>
          </div>
        </div>
      </div>
    </template>
  </customModal>
</template>
<script src="./RaiseQueryPopup.js"> </script>
<style scoped>
</style>
